import { cn } from '../../../utils/cn.js';

import { Footer } from './footer.jsx';
import Header from './header.jsx';

export default function PortalContainer({
  children,
  setScreen,
  className = '',
  header = true,
  headerUserSection = true,
  footer = true,
}) {
  return (
    <div className={cn('grid min-h-[100svh] w-full grid-cols-1')}>
      {header && (
        <Header headerUserSection={headerUserSection} setScreen={setScreen} />
      )}
      <div className={cn('p-6 xl:px-28 xl:pb-20', className)}>{children}</div>
      {footer && <Footer />}
    </div>
  );
}
